// frontend/src/pages/PatientNotFound.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header/Header';
import SearchBar, { SearchBarProps } from '../components/SearchBar/SearchBar';
import Background from '../components/Background/Background';
import helixImg from '../assets/helix.png';
import '../styles/PatientNotFound.css';
import { useAuth0 } from '@auth0/auth0-react';
import { fetchWithAuth } from '../api/fetchWithAuth';

const PatientNotFound: React.FC = () => {
  const [ssn, setSsn] = useState('');
  const [activeTab, setActiveTab] = useState<'medications' | 'history'>('medications');
  const navigate = useNavigate();

  const API_BASE = 'https://api-staging.mitoflux.is';
  const { getAccessTokenSilently } = useAuth0();

  const handleSearch = async () => {
    if (!ssn.trim()) return;

    try {
      const response = await fetchWithAuth(
        getAccessTokenSilently,
        `${API_BASE}/api/patients/${encodeURIComponent(ssn.trim())}`
      );
      if (!response.ok) {
        const text = await response.text();
        throw new Error(`API ${response.status}: ${text}`);
      }

      await response.json();

      navigate(`/doctor?kennitala=${encodeURIComponent(ssn.trim())}`);
    } catch (error) {
      console.error('Villa við leit að sjúklingi:', error);
      // Stay on this page — patient still not found
    }
  };

  const searchProps: SearchBarProps = {
    value: ssn,
    onChange: setSsn,
    onSearch: handleSearch,
    onMenuClick: () => console.log('menu'),
  };

  return (
    <>
      <Header center={<SearchBar {...searchProps} />} />

      <div className="tabs">
        <button
          className={`tab ${activeTab === 'medications' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('medications');
            navigate('/doctor');
          }}
        >
          Lyfjaskammtanir
        </button>
        <button
          className={`tab ${activeTab === 'history' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('history');
            navigate('/doctor/changes');
          }}
        >
          Þínar fyrri breytingar
        </button>
      </div>
      <Background>
        <div className="not-found-message">
          <h2>
            Sjúklingur er ekki í skömmtun <br />
            hjá skömmtunaraðilum
          </h2>
        </div>
        <button
          className="start-subscription"
          onClick={() => {
            navigate('/doctor/start-subscription');
          }}
        >
          Hefja skömmtun fyrir sjúkling
        </button>
        <img src={helixImg} alt="Helix" className="background-helix" />
      </Background>
    </>
  );
};

export default PatientNotFound;
